import { NICmsContentComponent } from '@icms/core/content';
import { ICmsComponentCwvConfig } from '../../catalog/config/component.config';

export namespace NCmsNewsletterBlock {
    export const BLOCK_ID = 'newsletter-block';

    export interface IBlockDataContent extends NICmsContentComponent.IData, ICmsComponentCwvConfig {
        title?: string;
        bgColor?: string;
        image?: string;
        ctaText?: string;
        ctaStyle?: string;
    }
}
